<script type="ts">
  import GameList from "../components/GameList.svelte";
  import NewGameButton from "../components/NewGameButton.svelte";
</script>

<div>
  <NewGameButton />
  <GameList />
</div>
